import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import LogName from "../../components/log/LogDetail/LogName.tsx";
import {useLocationFormState} from "../../components/log/LogForm/LogUpdateForm";
import LogUpdateFormProvider from "../../components/log/LogForm/LogUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const LogUpdateEditPage = () => {
    
    useTitle(t`Update Log`);

    const { logId: id } = useParams();
    
    return (
        <Box data-testid="Log-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="Log-update-title"
                    >
                        <Trans>Edit Log</Trans>:  <LogName id={id}/>
                    </Typography>
                    <LogUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default LogUpdateEditPage;
